import Slip from './Slip';

export default Slip;
